const empty = '';
export default empty;
